import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const PaymentReturnHeaderRoot = superstyled({
  name: 'PaymentReturnHeader',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 3),
    backgroundColor: theme.palette.fixed.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
});
